import { TableCell, TableRow, Typography } from "@mui/material";

type Props = {
    colums: number,
    text: string
}

export function TableNotFoundData(props: Props) {
    return (<TableRow>
        <TableCell colSpan={props.colums}>
            <Typography align="center" sx={{ fontSize: 14 }}>{props.text}</Typography>
        </TableCell>
    </TableRow>);
}